<template>
    <vx-card>
        <template v-if="widgetData && widgetData.results.length" >
            <component :settings="settings" :is="'VuePerfectScrollbar'" :key="$vs.rtl" class="widget_scroll">
                <div class=" mb-5 scholarship_item">
                    <div class="flex justify-between">
                        <label class="text-sm font-light">{{$t('assessed')}}:</label>
                        <div class="flex" v-html="priceReplace(item.payment_assigned, 'text-primary')"></div>
                    </div>

                    <div class="flex justify-between mt-4">
                        <label class="text-sm font-light">{{$t('period')}}:</label>
                        <div >{{$moment(item.end_date).format('MMMM YYYY')}}</div>
                    </div>
                    <div class="flex justify-between mt-4">
                        <label class="text-sm font-light">{{$t('paid_out')}}:</label>
                        <div class="flex" v-html="priceReplace(item.total_payment, 'text-primary')"></div>
                    </div>
                    <div class=" flex justify-between mt-4">
                        <label class="text-sm font-light">{{$t('payment_date_s')}}:</label>
                        <div>{{$moment(item.date_pay).format("DD.MM.YYYY")}}</div>
                    </div>
                </div>
            </component>
        </template>

        <vs-alert :style="vs_alert_style" active="true" v-if="emptyMessage">
            {{$t('no_data_text')}}
        </vs-alert>
    </vx-card>
</template>

<script>
import { price } from '@/pages/Home/MyFinances/config'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
    props: {
        element: Object,
        vs_alert_style: Object,
    },
    data () {
        return {
            emptyMessage: false,
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: 0.60
            },
            widgetSetting: {
                api: '/finance/scholarship_payments/?page=1',
                uid: this.element.uid
            }
        }
    },
    components: {
        VuePerfectScrollbar
    },
    computed: {
        widgetData() {
            return this.$store.state.desktop.widgetData[this.widgetSetting.uid]
        },
        item(){
            return this.widgetData.results[this.widgetData.results.length - 1]
        }
    },
    created: function() {
        this.getWidgetData()
    },
    methods: {
        priceReplace(sum, color) {
            return price(sum, color)
        },
        async getWidgetData() {
            try {
                const res = await this.$store.dispatch('desktop/getWidgetData', this.widgetSetting)
                if(res && !res.results.length)
                    this.emptyMessage = true
            } catch(e) {
                this.emptyMessage = true
            }
        }
    }
}
</script>
